import React, { use, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LoginBackground from '../admin-login/components/LoginBackground';
import LoginCard from '../admin-login/components/LoginCard';
import LoginHeader from '../admin-login/components/LoginHeader';
import LoginFooter from '../admin-login/components/LoginFooter';
import PasswordResetForm from './components/PasswordResetForm';

const PasswordReset = () => {

    return (
    <div className="min-h-screen bg-background flex items-centerx pt-10 justify-center p-4">
      {/* Background */}
      <LoginBackground />
      
      {/* Main Content */}
      <div className="relative z-10 w-full max-w-md">
        <LoginCard>
          <LoginHeader />
          <PasswordResetForm/>
          <LoginFooter />
        </LoginCard>
      </div>
    </div>
  );
}

export default PasswordReset;